import React, { useContext } from "react";
import { GuideContext } from "../components/GatewayForm/GatewayForm.store";
import app from "../app";
import GatewayForm from "../components/GatewayForm/GatewayForm";
import { GuidedResults } from "../components/GatewayForm/steps/guided";
import FormContextWrapper from "../components/GatewayForm/config/FormContextWrapper";

function GuidedSearchResults() {
  const { setCurrentStep } = useContext(GuideContext);
  const [firstLoad, setFirstLoad] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!firstLoad) {
      setCurrentStep("", { redirect: false });
      setFirstLoad(true);
    }
  }, [setFirstLoad, setCurrentStep, firstLoad]);

  return (
    <>
      {/* <GatewayForm /> */}
      <FormContextWrapper>
        <GuidedResults />
      </FormContextWrapper>
    </>
  );
}

const GuidedSearchResultsApp = app(GuidedSearchResults);
export default GuidedSearchResultsApp;
